module.exports = __webpack_public_path__ + "static/media/iso.6da6e197.jpg";